var AddAdminsModal;

import mixin from './mixin.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import ShuttleListItem from './shuttle_list_admins_item.js';

export default AddAdminsModal = Vue.extend({
  mixins: [mixin],
  components: {
    "shuttle-list-item": ShuttleListItem
  },
  props: {
    accessesList: {
      type: Array,
      required: true
    },
    addAdminsCallback: {
      type: Function,
      required: true
    }
  },
  template: `<modal title='添加组织管理员' extendClass='organization-add-admin-modal' size='large' ref="modal">
  <div class="modal-body">
    <div class="shuttle-container">
      <shuttle-container-candidates
        :organizationId="organization.id"
        :queryUrl="resourceUrl"
        @selectedOrganizationIdChanged="updateSelectedOrganizationIdFunc"
        @userSelected="userSelectedFunc"
        ref="shuttleContainerCandidates" />

        <div class="shuttle-box right">
          <div class="justify-box mb-2">
            <div class="content light-gray-text">已选成员</div>
          </div>
          <div class="shuttle-list">
            <shuttle-list-item v-for="administration in administrations"
                                :key="administration.admin.id"
                                :admin="administration.admin"
                                :access='administration.access'
                                :accessesList='accessesList'
                                @deleteSelectedMember="deleteSelectedMember(administration.admin)"
                                @adminAccessChanged="adminAccessChangedFunc">
            </shuttle-list-item>
          </div>
        </div>
      </add-members-shuttle-container>
    </div>
  </div>
  <div class="modal-footer" slot="footer">
    <button class="outlined btn-default" @click='cancel'>取消</button>
    <button @click='addAdmins' :disabled='requestDisabled'>确定</button>
  </div>
</modal>`,
  data: function() {
    return {
      administrations: []
    };
  },
  computed: {
    resourceUrl: function() {
      return `/admin/organizations/${this.selectedOrganizationId}/administrators/query`;
    },
    requestDisabled: function() {
      return !this.administrations.length;
    }
  },
  methods: {
    addAdmins: function() {
      return this.addAdminsCallback(this.administrations);
    },
    userSelectedFunc: function(user) {
      return this.administrations.push({
        admin: user,
        access: this.accessesList[0]
      });
    },
    deleteSelectedMember: function(admin) {
      this.administrations = _.reject(this.administrations, function(administration) {
        return administration.admin.id === admin.id;
      });
      return this.$refs.shuttleContainerCandidates.deselectUser(admin);
    },
    adminAccessChangedFunc: function(administration) {
      var filter_administration;
      filter_administration = _.find(this.administrations, function(item) {
        return item.admin.id === administration.admin.id;
      });
      return filter_administration.access = administration.access;
    }
  }
});
